
const getSubtitleDefaultPropertiesByOrg = (organization: string | undefined): any => {
  const defaultProperties = {
    x: "50%",
    x_anchor: "50%",
    y_anchor: "50%",
    x_alignment: "50%",
    y_alignment: "50%",
    y: "90.122%",
    fill_color: "#ffffff",
    font_size: 45,
    background_color: "rgba(0,0,0,0.6)",
    background_x_padding: "30%",
    background_y_padding: "5%",
    background_border_radius: "10%",
    height: "15%",
    width: "96%"
  };
  switch (organization) {
    case "Comcast":
      return {
        ...defaultProperties,
        fill_color: "#1d1d1b",
        background_color: "#ffffff",
        background_border_radius: "0%"
      };
    case "International Rescue Committee":
      return {
        ...defaultProperties,
        background_color: "rgba(0,0,0,0.5)",
        background_border_radius: "0%"
      };
    case "Microsoft":
      return {
        ...defaultProperties,
        x: "10%",
        y: "84.8853%",
        width: "80%",
        height: "13.8086%",
        x_anchor: "0%",
        y_anchor: "0%",
        x_alignment: "50%",
        y_alignment: "50%",
        fill_color: "rgba(255,255,255,1)",
        shadow_color: "rgb(0, 0, 0, 0.7)",
        shadow_blur: "0 vmin",
        shadow_x: "0.2 vmin",
        shadow_y: "0.2 vmin",
        background_color: ""
      };
    case "Premise Health":
      return {
        ...defaultProperties,
        background_color: "rgba(0,0,0,0.85)"
      };
    default:
      return defaultProperties;
  }
};

export default getSubtitleDefaultPropertiesByOrg;
